import * as Mutations from '../../mutations';

export default {
  setNotification({ commit }, notification) {
    commit(Mutations.SET_NOTIFICATION, notification);
  },
  setErrorNotification({ commit }, errorNotification) {
    commit(Mutations.SET_ERROR_NOTIFICATION, errorNotification);
  },
};

